export default "__VITE_ASSET__Dmqyuvea__"